var getLayoutById = function getLayoutById(layouts, id) {
  var result = layouts.find(function (l) {
    return l.id === id;
  });
  if (!result) {
    throw new Error("Could not find layout ".concat(id));
  }
  return result;
};

export { getLayoutById };
//# sourceMappingURL=get-layout-by-id.esm.js.map
